import { tokenAmountFromProxy, tokenAmountToProxy } from "./tokenAmount";
export function ergoBoxFromProxy(proxy) {
    return {
        ...proxy,
        value: BigInt(proxy.value),
        assets: proxy.assets.map(t => tokenAmountFromProxy(t))
    };
}
export function ergoBoxToProxy(box) {
    return {
        ...box,
        value: box.value.toString(),
        assets: box.assets.map(t => tokenAmountToProxy(t))
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJnb0JveC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9lcmdvL2VudGl0aWVzL2VyZ29Cb3gudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFjLG9CQUFvQixFQUFvQixrQkFBa0IsRUFBQyxNQUFNLGVBQWUsQ0FBQTtBQTJCckcsTUFBTSxVQUFVLGdCQUFnQixDQUFDLEtBQW1CO0lBQ2xELE9BQU87UUFDTCxHQUFHLEtBQUs7UUFDUixLQUFLLEVBQUUsTUFBTSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUM7UUFDMUIsTUFBTSxFQUFFLEtBQUssQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsb0JBQW9CLENBQUMsQ0FBQyxDQUFDLENBQUM7S0FDdkQsQ0FBQTtBQUNILENBQUM7QUFFRCxNQUFNLFVBQVUsY0FBYyxDQUFDLEdBQVk7SUFDekMsT0FBTztRQUNMLEdBQUcsR0FBRztRQUNOLEtBQUssRUFBRSxHQUFHLENBQUMsS0FBSyxDQUFDLFFBQVEsRUFBRTtRQUMzQixNQUFNLEVBQUUsR0FBRyxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxrQkFBa0IsQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUNuRCxDQUFBO0FBQ0gsQ0FBQyJ9